import CoreSigmaModal from "./CoreSigmaModal";
const sigmaBindings = {
  "eventDefinitions.components.editSigmaModal": [
    {
      component: CoreSigmaModal,
      key: "coreSigmaModal"
    }
  ]
};
export default sigmaBindings;
